export { WatchmanPrayFlow as default } from '@/src/features/watchman/ui/screens/WatchmanPrayFlowScreen/WatchmanPrayFlow'
